import React from "react";
import { CheckOutlined } from "@ant-design/icons";

import { sectionHeading } from "../TreatmentPlans/component/shared/PatientInfoCard";
import { REQUEST_TYPES, REQUEST_TYPE_ORDER } from "./requestTypes";

/**
 * The first step — what do you need.
 *
 * Only the three requests, as cards rather than a dropdown: this is the one
 * genuine decision in the flow, and a select hides it behind a click. They are
 * rendered from REQUEST_TYPES so a type is added in one place. None is
 * pre-selected (Continue stays off until one is picked); each card carries a
 * check circle so the choice reads as a choice rather than a heading.
 */
export default function RequestTypeStep({ requestType, onRequestType }) {
  return (
    <div>
      <div className="ir-step-heading is-first">{sectionHeading("What do you need")}</div>
      <div className="ir-choices" role="radiogroup" aria-label="What do you need">
        {REQUEST_TYPE_ORDER.map(function (key) {
          const t = REQUEST_TYPES[key];
          const selected = requestType === key;
          return (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={selected}
              className={"ir-choice" + (selected ? " is-selected" : "")}
              onClick={function () { onRequestType(key); }}
            >
              <span className="ir-choice-check" aria-hidden>
                {selected ? <CheckOutlined /> : null}
              </span>
              <div className="ir-choice-title">{t.cardTitle}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
